<template>
  <div
    id="modalAddUser"
    class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center p-10"
    v-bind:class="isShowingModal ? 'z-50' : 'opacity-0 pointer-events-none'"
  >
    <div
      class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
    ></div>

    <div
      class="modal-container
          bg-white w-11/12 md:max-w-none mx-auto rounded shadow-lg z-50 overflow-y-auto"
    >
      <a v-if="!isHideToggle" @click="toggleModal()" >
        <div
          class="modal-close
                 absolute
                 top-0
                 right-0
                 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
        >
          <svg
            class="fill-current text-white"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
          >
            <!-- eslint-disable max-len -->
            <path
              d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
            ></path>
            <!-- eslint-enable max-len -->
          </svg>
          <span class="text-sm">(Esc)</span>
        </div>
      </a>

      <!-- Add margin if you want to see some of the overlay behind the modal-->
      <div class="modal-content py-4 text-left px-6">
        <!--Title-->
        <div class="flex justify-between items-center pb-3">
          <div class="flex-row" >
              <p class="text-2xl font-bold">Terms and Conditions</p>
              <p class="font-bold" ></p>
          </div>
          <div class="modal-close cursor-pointer z-50">
            <a v-if="!isHideToggle" @click="toggleModal()">
              <svg
                class="fill-current text-black"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
              >
                <!-- eslint-disable max-len -->
                <path
                  d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                ></path>
                <!-- eslint-enable max-len -->
              </svg>
            </a>
          </div>
        </div>

        <!--Body-->
        <!-- eslint-disable max-len -->
        <div
          class="flex w-full overflow-y-auto overflow-x-hidden border text-black rounded-r-md"
          style="max-height: 50vh;">
          <div v-html="contentTermsOfCondition" ></div>
        </div>
        <!-- eslint-enable max-len -->

        <!--Footer-->
        <div class="flex flex-wrap justify-center text-black pt-2">
          <div class="w-full text-center p-5" >
            <!-- eslint-disable max-len -->
            <input type="checkbox" v-model="agreement" :disabled="isLoading" > I have read and accepted the Terms & Conditions
            <!-- eslint-enable max-len -->
          </div>
          <button
            class="modal-close px-4 bg-blue-500 p-3 rounded-lg text-white hover:bg-blue-400"
            :class="!agreement ? 'opacity-50 cursor-not-allowed' : ''"
            @click="save()"
            :disabled="!agreement"
          >
            <!-- eslint-disable max-len -->
            {{labelSaveButton}}
            <!-- eslint-enable max-len -->
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ModalTermAndConditions',
  data: () => ({
    agreement: false,
  }),
  props: {
    title: {
      type: String,
      default: '',
    },
    isShowingModal: {
      type: Boolean,
      default: false,
    },
    isHideToggle: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    await this.requestContentTermOfConditionPublic();
  },
  computed: {
    ...mapGetters('TermsOfConditionModule', ['contentTermsOfCondition']),
    labelSaveButton() {
      return 'Submit';
    },
  },
  methods: {
    ...mapActions('TermsOfConditionModule', ['requestContentTermOfConditionPublic']),
    toggleModal() {
      this.$emit('toggleModal');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Common/ModalTermAndConditions.vue